import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import backgroundSound from '@/assets/sounds/background.mp3'
import icecrackoneSound from '@/assets/sounds/icecrackone.mp3'
import icecracktwoSound from '@/assets/sounds/icecracktwo.mp3'
import icecrackthreeSound from '@/assets/sounds/icecrackthree.mp3'
import icecrackfourSound from '@/assets/sounds/icecrackfour.mp3'
import snowswipeoneSound from '@/assets/sounds/snowswipeone.mp3'
import snowswipetwoSound from '@/assets/sounds/snowswipetwo.mp3'
import soundTap from "@/assets/sounds/tap.mp3";

let disableScrollHandler = function (e) {
  if (e.cancelable) {
    e.preventDefault();
  }
};

export const store = new Vuex.Store({
  state: {
    language: 'en',
    termsOverlay: false,
    country: null,
    glassColor: 'green',
    sounds: {
      backgroundSound: new Audio(backgroundSound),
      icecrackoneSound: new Audio(icecrackoneSound),
      icecracktwoSound: new Audio(icecracktwoSound),
      icecrackthreeSound: new Audio(icecrackthreeSound),
      icecrackfourSound: new Audio(icecrackfourSound),
      snowswipeoneSound: new Audio(snowswipeoneSound),
      snowswipetwoSound: new Audio(snowswipetwoSound),
      tapSound: new Audio(soundTap),
    },
    gameFinished: false,
  },
  mutations: {
    setGameFinished (state, val) {
      state.gameFinished = val
    },
    setLanguage (state, val) {
      state.language = val
    },
    setCountry (state, val) {
      state.country = val
    },
    setGlassColor (state, val) {
      state.glassColor = val
    },
    setTermsOverlay (state, val) {
      state.termsOverlay = val
    },
    setScrollDisabled(state, value) {
      state.isScrollDisabled = value;
      if (value) {
        document.addEventListener(
          "touchmove",
          disableScrollHandler,
          { passive: false }
        );
        console.log("scroll removed");
      } else {
        console.log("scroll added");
        document.removeEventListener("touchmove", disableScrollHandler);
      }
    },
  },
  actions: {
    disableScroll({ commit }) {
      commit("setScrollDisabled", true); 
    },
    enableScroll({ commit }) {
      commit("setScrollDisabled", false);
    },
  },
})

export default store
